var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialBLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.04727 9.90455C9.04727 8.95182 10.19 9.04727 10.19 9.04727H21.9045V16.2855C21.9045 21.2382 17.0473 22 17.0473 22H9.04727V16.2855H15.7136C16.38 16.2855 16.38 15.6191 16.38 15.6191V14.2855H9.04727V9.90455Z",
    fill: "#05070D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33273 2H21.81L21.8091 7.52364H8.66636C8.66636 7.52364 7.52364 7.71455 7.52364 8.85727V22H2V7.52364C2 7.52364 2.09545 3.23818 7.33273 2Z",
    fill: "#05070D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialBLight);
export default __webpack_public_path__ + "static/media/social-b-light.7fc1e6d4ac16fb537c37097413a33aad.svg";
export { ForwardRef as ReactComponent };